"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onSeeking;
function onSeeking(event) {
  this._playerState.seeking = true;
  this.logger.times.SeekTime = performance.now();
  this.emit('seeking', event);
}